import _sfc_main from './bgm-content.vue2.js';
/* empty css                */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const BgmContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-7b7bab70"]]);

export { BgmContent as default };
//# sourceMappingURL=bgm-content.js.map
